import { CONFIG } from '../config';

export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isProduction = () => CONFIG.IMAGE_TAG === 'production';
